import { useTranslation } from '@rpi/i18n';

const ContactSupport = () => {
  const { t, i18n } = useTranslation(undefined, { keyPrefix: 'route.auth' });

  const supportUrl = `https://support.blurb.com/hc/${i18n.language}`;
  return (
    <div className="text-center">
      <a target="_blank" rel="noopener noreferrer" href={supportUrl}>
        {t('contact_support')}
      </a>
    </div>
  );
};

export default ContactSupport;
